
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'Admin',
  SRE: 'SRE',
  APP_OWNER: 'Client',
  FINOPS: 'finopsupport'
};

export const rolePermissions = {
  [ROLES.SUPER_ADMIN]: [
    'view_all_resources',
    'create_resources',
    'delete_resources',
    'manage_users',
    'approve_requests',
    'view_billing',
    'manage_policies'
  ],
  [ROLES.ADMIN]: [
    'view_resources',
    'create_resources',
    'approve_requests',
    'manage_users',
    'view_billing'
  ],
  [ROLES.SRE]: [
    'view_resources',
    'manage_infrastructure',
    'monitor_systems',
    'incident_management'
  ],
  [ROLES.APP_OWNER]: [
    'view_own_resources',
    'request_resources',
    'view_own_billing'
  ],
  [ROLES.FINOPS]: [
    'view_billing',
    'cost_optimization',
    'budget_management',
    'view_all_resources'
  ]
};

export const getDashboardConfig = (role) => {
  const configs = {
    [ROLES.SUPER_ADMIN]: {
      title: 'Super Admin Dashboard',
      color: '#1976d2',
      widgets: ['overview', 'resources', 'approvals', 'users', 'billing', 'incidents'],
      charts: ['resource_trends', 'cost_analysis', 'approval_metrics']
    },
    [ROLES.ADMIN]: {
      title: 'Admin Dashboard',
      color: '#388e3c',
      widgets: ['overview', 'resources', 'approvals', 'users', 'billing'],
      charts: ['resource_trends', 'cost_analysis']
    },
    [ROLES.SRE]: {
      title: 'SRE Dashboard',
      color: '#f57c00',
      widgets: ['infrastructure', 'monitoring', 'incidents', 'performance'],
      charts: ['system_health', 'performance_metrics', 'incident_trends']
    },
    [ROLES.APP_OWNER]: {
      title: 'App Owner Dashboard',
      color: '#7b1fa2',
      widgets: ['my_resources', 'requests', 'my_billing'],
      charts: ['my_cost_trends', 'resource_usage']
    },
    [ROLES.FINOPS]: {
      title: 'FinOps Dashboard',
      color: '#c62828',
      widgets: ['cost_overview', 'budget_tracking', 'optimization', 'forecasting'],
      charts: ['cost_breakdown', 'savings_opportunities', 'budget_variance']
    }
  };
  
  return configs[role] || configs[ROLES.APP_OWNER];
};
